export const legalHrToolsArticle = {
  title: 'Legal & HR Document Hub: Tools Overview',
  slug: 'legal-hr-tools',
  content: `Legal & HR Document Hub: Tools Overview

Access the Legal & HR tools collection from one dashboard.

1) Open the hub
- Go to /legal-hr.

2) Core tools
- Contract Analyzer
- Privacy Policy Generator
- Terms & Conditions Generator
- Employee Handbook Creator
- NDA Generator
- Contractor Agreement Generator
- HR Policy Generator

3) People tools
- Staff Management (team records and scheduling)
- Recruitment Portal (ATS workflows)

4) Support Desk
- AI Support Desk opens the support module for customer tickets.
`,
};
